import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=4b6170ce&scoped=true&"
import script from "./ChatMessage.vue?vue&type=script&lang=ts&"
export * from "./ChatMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=4b6170ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6170ce",
  null
  
)

export default component.exports